import './CalendarPersonnelList.scss'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { RadioButton } from 'primereact/radiobutton'
import { InputText } from 'primereact/inputtext'
import userIcon from './../../../assets/icons/user-icon.svg'
import { ICalendarPersonnalModel, IEmployeeSummary, ISearchFirmEmployee } from '../../../types/Employee'
import loadingEmployees from './../../../assets/icons/loading-employees.png'
import AsyncImage from '../../ui/AsyncImage'
import useDidMountEffect from '../../../utils/useDidMountEffect'
import { TreeTable } from 'primereact/treetable'
import { Column } from 'primereact/column'
import TreeNode from 'primereact/treenode'
import EmployeeService from '../../../service/EmployeeService'
import Avatar from '../../../assets/images/avatar.png'
import { bindActionCreators } from 'redux'
import { actionCreators } from '../../../state/state-index'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Loader from 'components/ui/Loader'

const CalendarPersonnelList = (
  props: {
    data: ICalendarPersonnalModel
    employeeSummary: IEmployeeSummary
    onClickPersonnel: (arg0: any) => any
    onClickSquadsEvents: (arg0: any) => any
    showSquadsEvents: (arg0: any) => any
    searchFirmEmployee: ISearchFirmEmployee[]
    onSearchFirmEmployee: (arg0: any) => any
    onIsMyCalendar: (arg0: any) => any
  },
  ref: any
) => {
  const { t } = useTranslation()
  let categories = [
    { name: t('calendar.my-squad'), label: 'calendar.my-squads-calendar', key: 'SQUAD' },
    { name: t('calendar.my-team'), label: 'calendar.my-teams-calendar', key: 'TEAM' },
    { name: t('calendar.my-firm'), label: 'calendar.my-firms-calendar', key: 'OTHER' },
  ]

  const [selectedCategory, setSelectedCategory] = useState(categories[0])

  const [value3, setValue3] = useState('')
  const [selectedId, setSelectedId] = useState(-1)
  const [showProfileBackground, setShowProfileBackground] = useState(true)
  const [showSquadsEvents, setShowSquadsEvents] = useState(false)
  const [tempData, setTempData] = useState<IEmployeeSummary[] | ISearchFirmEmployee[]>()
  const [nodes, setNodes] = useState<TreeNode[]>([])

  const dispatch = useDispatch()
  const { cleanDaysState } = bindActionCreators(actionCreators, dispatch)

  useEffect(() => {
    let { employeeSummary } = props
    if (employeeSummary) {
      if (employeeSummary.isManager) {
        if (props.data) {
          if (props.data.hasOwnProperty('squads') && props.data?.squads) {
            let squads = [...props.data?.squads]
            if (squads) changePersonnalListItems({ ...categories[0] })
          } else {
            // squads yoksa boş array set et
            setTempData([])
            setNodes([])
          }
        }
      } else {
        if (props.data) {
          if (props.data.hasOwnProperty('teams') && props.data?.teams) {
            let teams = [...props.data?.teams]
            if (teams) changePersonnalListItems({ ...categories[1] })
          } else {
            // teams yoksa boş array set et
            setTempData([])
          }
        }
      }
    }
  }, [props.data, props.employeeSummary])

  useImperativeHandle(ref, () => ({
    setTempDataFromParent() {
      if (props.data.teams) {
        let teams = [...props.data?.teams]
        teams.sort(function (a, b) {
          // @ts-ignore
          return b.isMyManager - a.isMyManager
        })
        setTempData(teams)
      }
    },
  }))

  const getSelectedBackground = (id: number) => {
    if (selectedId === null || selectedId === -1) return 'bg-white'
    return selectedId === id ? 'bg-selected-blue' : 'bg-white'
  }

  const showBackground = () => {
    return showProfileBackground ? 'bg-selected-blue' : 'bg-white'
  }

  const findPersonInList = (val: any) => {
    const terms = val.split(' ')

    if (selectedCategory.key === 'SQUAD') {
      if (props.data?.squads) {
        let clonedTempData = [...props.data.squads]
        let filteredData = clonedTempData.filter((f) =>
          terms.every((w: any) => f.fullName.toLowerCase().includes(w.toLowerCase()))
        )
        filteredData.sort(function (a, b) {
          // @ts-ignore
          return b.isMyManager - a.isMyManager
        })
        setNodeData(filteredData)
      }
    } else {
      if (props.data?.teams) {
        let clonedTempData = [...props.data.teams]
        let filteredData = clonedTempData.filter((f) =>
          terms.every((w: any) => f.fullName.toLowerCase().includes(w.toLowerCase()))
        )
        filteredData.sort(function (a, b) {
          // @ts-ignore
          return b.isMyManager - a.isMyManager
        })
        setTempData(filteredData)
      }
    }
  }

  const findEmployeeList = (val: any) => {
    if (val.length > 0) {
      setTempData(undefined)
      props.onSearchFirmEmployee(val)
    } else {
      setTempData([])
    }
  }

  useDidMountEffect(() => {
    if (value3 === '') {
      setTempData([])
    } else {
      let clonedTempData = [...props.searchFirmEmployee]
      const terms = value3.split(' ')
      let filteredData = clonedTempData.filter((f) =>
        terms.every((w: any) => f.fullName.toLocaleLowerCase().includes(w.toLocaleLowerCase()))
      )
      filteredData.sort(function (a, b) {
        // @ts-ignore
        return b.isMyManager - a.isMyManager
      })

      setTempData(filteredData)
    }
  }, [props.searchFirmEmployee])

  const changePersonnalListItems = (value: any) => {
    setSelectedCategory(value)
    setValue3('')
    let { key } = value
    if (key === 'SQUAD') {
      // team
      if (props.data?.squads) {
        let clonedTempData = [...props.data.squads]
        clonedTempData.sort(function (a, b) {
          // @ts-ignore
          return b.isMyManager - a.isMyManager
        })
        setNodeData(clonedTempData)
        setTempData(clonedTempData)
      }
    } else if (key === 'TEAM') {
      // squad
      if (props.data?.teams) {
        let clonedTempData = [...props.data.teams]
        clonedTempData.sort(function (a, b) {
          // @ts-ignore
          return b.isMyManager - a.isMyManager
        })
        setTempData(clonedTempData)
      }
    } else if (key === 'OTHER') {
      setTempData([])
    }
  }

  const setNodeData = (tempData: any[]) => {
    let _tempData = tempData.map(
      (val1, index1) =>
        ({
          key: index1.toString(),
          data: { ...val1, _PhotoUrl: EmployeeService.getEmployeePhotoUrl(val1) },
          children: val1.mySquad?.map(
            (val2: any, index2: number) =>
              ({
                key: index1.toString() + '-' + index2.toString(),
                data: { ...val2, _PhotoUrl: EmployeeService.getEmployeePhotoUrl(val2) },
                children: val2.mySquad?.map(
                  (val3: any, index3: number) =>
                    ({
                      key: index1.toString() + '-' + index2.toString() + '-' + index3.toString(),
                      data: { ...val3, _PhotoUrl: EmployeeService.getEmployeePhotoUrl(val3) },
                      children: undefined,
                    } as TreeNode)
                ),
              } as TreeNode)
          ),
        } as TreeNode)
    )
    _tempData.map((data, index) => {
      // @ts-ignore
      if (data?.children?.length > 0) {
        // @ts-ignore
        data?.children.unshift({
          key: index.toString() + '-' + data.children?.length.toString() + '-squads',
          data: data.data,
          children: [],
        })
      }
      return data
    })
    // @ts-ignore
    setNodes(_tempData as TreeNode)
  }

  const getProfilePictureBase64 = () => {
    return localStorage.getItem('employeePhoto')
  }

  const actionTemplate = (employee: TreeNode, column: any) => {
    // @ts-ignore
    let keys = employee?.key.toString()
    // @ts-ignore
    let squadsButton = employee?.key.toString().charAt(employee?.key.toString().length - 1) === 's'

    if (squadsButton) {
      return (
        <div
          style={{ marginLeft: keys.length > 1 ? '16px' : keys.length > 3 ? '20px' : '0px', marginRight: '5px' }}
          key={employee?.data.Id}
          className={'of-personnel w-100 d-flex flex-row mb-3 ' + getSelectedBackground(employee.data.Id)}
          onClick={() => {
            setSelectedId(employee.data.id)
            setShowProfileBackground(false)
            props.onClickSquadsEvents(employee.data)
          }}>
          <div className="p-2 d-flex align-items-center">
            <AsyncImage src={loadingEmployees} className={'of-photo of-calendar-photo'} />
          </div>
          <div className="p-2">
            <div className={'of-name'}>{employee?.data.fullName}</div>
            <div className={'of-name'}>{t('calendar.your-squads-calendar')}</div>
          </div>
        </div>
      )
    } else {
      return (
        <div
          style={{ marginLeft: keys.length > 1 ? '16px' : keys.length > 3 ? '20px' : '0px', marginRight: '5px' }}
          key={employee?.data.id}
          className={'of-personnel w-100 d-flex flex-row mb-3 ' + getSelectedBackground(employee.data.id)}
          onClick={() => {
            setSelectedId(employee.data.id)
            setShowProfileBackground(false)
            props.onClickPersonnel(employee.data)
          }}>
          <div className="p-2 d-flex align-items-center">
            <AsyncImage src={employee?.data._photoUrl} className={'of-photo of-calendar-photo'} />
          </div>
          <div className="p-2">
            <div className={'of-name'}>{employee?.data.fullName}</div>
            <div className={'of-title'}>{employee?.data.positionName}</div>
          </div>
        </div>
      )
    }
  }

  return (
    <div className={'of-cal-personnel-list'}>
      <div className=" d-flex flex-row mb-3">
        <div className={'of-personnel-title'}>{t('calendar.my-calendar')}</div>
      </div>
      <div
        className={'of-personnel d-flex flex-row mb-4 of-personnel-hover ' + showBackground()}
        onClick={() => {
          setShowProfileBackground(true)

          setSelectedId(-1)
          setShowSquadsEvents(false)
          props.onIsMyCalendar(true)
          props.onClickPersonnel(props.employeeSummary)
        }}>
        <div className="p-2 d-flex align-items-center">
          <img
            className={'of-photo of-calendar-photo'}
            src={getProfilePictureBase64() !== '' ? 'data:image/png;base64,' + getProfilePictureBase64() : Avatar}
            alt=""
          />
        </div>
        <div className="p-2">
          <div className={'of-name'}>{props.employeeSummary?.fullName}</div>
          <div className={'of-title'}>{props.employeeSummary?.positionName}</div>
        </div>
      </div>

      {props.employeeSummary?.isManager ? (
        <div className="row d-flex align-items-center justify-content-center bd-highlight mb-3 radio-button-container">
          <div key={categories[0].key} className="col-12 col-lg-4 py-0 d-flex align-items-center">
            <RadioButton
              className={'me-1'}
              inputId={categories[0].key}
              name="category"
              value={categories[0]}
              onChange={(e) => {
                changePersonnalListItems(e.value)
              }}
              checked={selectedCategory?.key === categories[0].key}
            />
            <label htmlFor={categories[0].key}>{categories[0].name}</label>
          </div>
          <div key={categories[1].key} className="col-12 col-lg-4 py-0 d-flex align-items-center">
            <RadioButton
              className={'me-1'}
              inputId={categories[1].key}
              name="category"
              value={categories[1]}
              onChange={(e) => {
                changePersonnalListItems(e.value)
              }}
              checked={selectedCategory?.key === categories[1].key}
            />
            <label htmlFor={categories[1].key}>{categories[1].name}</label>
          </div>
          <div key={categories[2].key} className="col-12 col-lg-4 py-0 d-flex align-items-center">
            <RadioButton
              className={'me-1'}
              inputId={categories[2].key}
              name="category"
              value={categories[2]}
              onChange={(e) => {
                changePersonnalListItems(e.value)
              }}
              checked={selectedCategory?.key === categories[2].key}
            />
            <label htmlFor={categories[2].key}>{categories[2].name}</label>
          </div>
        </div>
      ) : (
        <div className="d-flex flex-row justify-content-center bd-highlight mb-3">
          <div key={categories[1].key} className="p-2 d-flex align-items-center">
            <RadioButton
              className={'me-1'}
              inputId={categories[1].key}
              name="category"
              value={categories[1]}
              onChange={(e) => {
                changePersonnalListItems(e.value)
              }}
              checked={selectedCategory?.key === categories[1].key}
            />
            <label htmlFor={categories[1].key}>{categories[1].name}</label>
          </div>
          <div key={categories[2].key} className="p-2 d-flex align-items-center">
            <RadioButton
              className={'me-1'}
              inputId={categories[2].key}
              name="category"
              value={categories[2]}
              onChange={(e) => {
                changePersonnalListItems(e.value)
              }}
              checked={selectedCategory?.key === categories[2].key}
            />
            <label htmlFor={categories[2].key}>{categories[2].name}</label>
          </div>
        </div>
      )}

      <div className={'of-personnel-title my-3'}>{t(selectedCategory?.label)}</div>

      {props.employeeSummary?.isManager && (
        <div
          className={
            'of-personnel d-flex flex-row mb-3 of-personnel-hover ' +
            (showSquadsEvents ? 'bg-selected-blue' : 'bg-white')
          }
          onClick={() => {
            cleanDaysState(true)
            setShowProfileBackground(false)

            setShowSquadsEvents(true)
            props.onIsMyCalendar(false)
            props.showSquadsEvents(props.employeeSummary)
          }}>
          <div className="p-2 d-flex align-items-center">
            <img className={'of-photo of-calendar-photo'} src={loadingEmployees} alt="" />
          </div>
          <div className="squads-calender p-2">
            <div className={'of-name'}>{t('calendar.my-squads-calendar')}</div>
          </div>
        </div>
      )}

      <span className="p-input-icon-left w-100">
        <i className="pi ">
          <img src={userIcon} alt="" />
        </i>
        {selectedCategory?.key === categories[2].key ? (
          <span className="p-input-icon-right w-100">
            {value3 !== '' && (
              <i
                className="pi pi-times"
                onClick={() => {
                  setValue3('')
                  findEmployeeList('')
                }}
                style={{ cursor: 'pointer' }}
              />
            )}

            <InputText
              className={'w-100 of-name-search'}
              value={value3}
              onChange={(e) => {
                setValue3(e.target.value)
                findEmployeeList(e.target.value)
              }}
              placeholder={t('input-texts.search-someone')}
            />
          </span>
        ) : (
          <span className="p-input-icon-right w-100">
            {value3 !== '' && (
              <i
                className="pi pi-times"
                onClick={() => {
                  setValue3('')
                  findPersonInList('')
                }}
                style={{ cursor: 'pointer' }}
              />
            )}
            <InputText
              className={'w-100 of-name-search'}
              value={value3}
              onChange={(e) => {
                setValue3(e.target.value)
                findPersonInList(e.target.value)
              }}
              placeholder={t('input-texts.search-someone')}
            />
          </span>
        )}
      </span>

      <div className={'of-personnels my-3'}>
        {tempData ? (
          selectedCategory?.key === categories[0].key ? (
            <TreeTable value={nodes} emptyMessage={t('calendar.no-user')}>
              <Column expander body={actionTemplate} style={{ padding: '0px !important' }} />
            </TreeTable>
          ) : tempData.length > 0 ? (
            tempData.map((employee) => (
              <div
                key={employee?.id}
                className={'of-personnel d-flex flex-row mb-3 ' + getSelectedBackground(employee.id)}
                onClick={() => {
                  setSelectedId(employee.id)
                  setShowProfileBackground(false)
                  props.onClickPersonnel(employee)
                }}>
                <div className="p-2 d-flex align-items-center">
                  <AsyncImage src={EmployeeService.getEmployeePhotoUrl(employee as any)} className={'of-photo of-calendar-photo'} />
                </div>
                <div className="p-2">
                  <div className={'of-name'}>{employee?.fullName}</div>
                  <div className={'of-title'}>{employee?.positionName}</div>
                </div>
              </div>
            ))
          ) : (
            value3 !== '' && <p style={{ color: '#495057' }}>{t('calendar.no-user')}</p>
          )
        ) : (
          <>
            <Loader src={loadingEmployees} />
          </>
        )}
      </div>
    </div>
  )
}

export default forwardRef(CalendarPersonnelList)
